export default "__VITE_ASSET__B$Pfw2oC__"